// Socket.IO client multi-namespace (/inbox, /production, /system).
// Singleton por namespace — uma instância só por ns durante a sessão (readme §6).
import { io, type Socket } from 'socket.io-client';
import { env } from '@/config/env';
import { WS_NAMESPACES, type WsNamespace } from '@/config/constants';
import { getToken } from '../auth/token-storage';

const sockets = new Map<WsNamespace, Socket>();

export function getSocket(ns: WsNamespace): Socket {
  const existing = sockets.get(ns);
  if (existing) return existing;

  // Em produção conectamos na MESMA origem (`''`) — o nginx (host + container web)
  // já encaminha `/socket.io/` pra api:3000. Assim funciona em qualquer domínio
  // (staging/stable) sem assar a URL no build. Em dev mantemos `VITE_WS_URL`
  // (localhost:3000) pra bater direto na API. Sem isso o build caía no default
  // localhost e o WS quebrava em staging.
  const wsBase = import.meta.env.PROD ? '' : env.VITE_WS_URL;

  const socket = io(`${wsBase}${WS_NAMESPACES[ns]}`, {
    path: '/socket.io',
    autoConnect: false,
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 30_000,
    auth: (cb) => cb({ token: getToken() }),
  });

  sockets.set(ns, socket);
  return socket;
}

export function disconnectAll(): void {
  for (const socket of sockets.values()) {
    socket.disconnect();
  }
  sockets.clear();
}
